import type { Datum } from '@nivo/scatterplot'

import { fromCents } from 'modules/core/lib/formatCurrencyUtils'

import type { SalaryDistribution } from 'modules/job_catalog/hooks/useSalariesDistribution'

export interface SalaryDatum extends Datum {
  targetMin: number
  targetMax: number
  currency: string
  count: number
  country?: string
}

export const buildSerieData = (
  salaryDistribution: SalaryDistribution,
  initialData: SalaryDatum[] = []
): SalaryDatum[] => {
  const {
    contractCuratedSalary,
    jobCatalogLevel,
    curatedJobCatalogLevelSalaryMaxRange,
    curatedJobCatalogLevelSalaryMinRange,
    legalEntityCurrency,
  } = salaryDistribution
  if (!contractCuratedSalary) return initialData

  return [
    ...initialData,
    {
      y: contractCuratedSalary,
      x: jobCatalogLevel || '',
      targetMin: fromCents(curatedJobCatalogLevelSalaryMinRange || 0),
      targetMax: fromCents(curatedJobCatalogLevelSalaryMaxRange || 0),
      currency: legalEntityCurrency as string,
      count: 1,
      country: salaryDistribution.legalEntity?.country,
    },
  ]
}
